// extracted by mini-css-extract-plugin
export default {"leftNavBar":"styles_leftNavBar__hZqPr","menu":"styles_menu__GMQDc","isActive":"styles_isActive__o3YVI"};